var colors = {
    blueHeader: '#131927',
    blueSubheader: '#202B43',
    blueLineEdit: '#1A2235',
    blueBackground: '#29334c',
    blueAlternate: '#252d44',
    blueGradient: '#1D263B',
    blueGrey: '#4e5565',
    tableBGBlue: '#1b2234',
    tableBorderGrey: '#4e5159',
    gradientDisabled: '#25304A',
    yellow: '#EEE756',
    orange: '#AA7221',
    white: '#FFFDE5',
    black: '#000000',
    grey: '#80807F',
    greenSelected: '#399E6B',
    blueSelected: '#1A2134',
    red: '#FF0000',
    green_: '#00FF00',
    standbyGreen: '#108229',
    lightBlue: '#55AAFF',
    lightOrange: '#FF8000',
    lightBOT: '#99A9B3',
    lightBrown: '#A28131',
    ORF_background_top: '#29385A',
    ORF_background_bottom: '#142040',
    ORF_highlighted_top: '#3B4E77',
    ORF_highlighted_bottom: '#293A5F',
    ORF_pressed_top: '#151C2B',
    ORF_pressed_bottom: '#272A39',
    border: '#191c2f',
    darkBorder: '#06101f',
    ORF_disabled_color: '#646464',
    IFF_darkblue: '#FFFFFF',
    IFF_yellow: '#000000',
};
var catizTheme = {
    line: {
        borderColor: '#33415e',
    },
    label: {
        flexDirection: 'column',
        justifyContent: 'center',
        color: colors.yellow,
        fontSize: '14px',
        header: {
            subheaderbgColor: colors.blueSubheader,
            headerbgColor: colors.blueHeader,
        },
        border: '1px solid',
        borderColor: colors.blueGrey,
    },
    groupBox: {
        border: 'none',
        fieldset: {
            border: '2px groove threedface',
        },
    },
    window: {
        background: '#2b3958',
        border: "5px ridge #4F94CD",
        title: {
            background: colors.blueSelected,
            color: 'white',
        },
        content: {
            background: 'rgb(43, 56, 86)',
        },
        fontSize: '14px',
        fontFamily: 'DejaVu Sans Mono',
    },
    comboBox: {
        color: colors.white,
        border: '1px solid',
        backgroundColor: colors.blueLineEdit,
        borderColor: {
            top: colors.blueGrey,
            left: colors.blueGrey,
            right: colors.blueGrey,
            bottom: colors.blueGrey,
        },
    },
    radio: {
        input: {
            accentColor: '#37a068',
        },
        label: {
            color: colors.white,
        },
    },
    textInput: {
        backgroundColor: colors.blueLineEdit,
        border: '1px solid',
        borderColor: {
            top: colors.blueGrey,
            left: colors.blueGrey,
            right: colors.blueGrey,
            bottom: colors.blueGrey,
        },
    },
    dataGrid: {
        position: 'relative',
        table: {
            border: '1px solid',
            borderColor: colors.tableBorderGrey,
            backgroundColor: colors.tableBGBlue,
            thead: {
                tr: {
                    th: {
                        backgroundColor: '#3f4c66',
                        fontWeight: 'normal',
                        textAlign: 'center',
                        rowHeader: {
                            textAlign: 'left',
                        },
                    },
                },
            },
            tbody: {
                tr: {
                    selectedBgColor: colors.lightBlue,
                    selectedFontColor: colors.white,
                },
            },
        },
    },
    textArea: {
        background: colors.blueLineEdit,
    },
    tabNavigator: {
        nav: {
            height: '22px',
            item: {
                backgroundColor: colors.blueHeader,
                color: colors.yellow,
                active: {
                    backgroundColor: '#2b3958',
                },
            },
        },
    },
    listWidget: {
        backgroundColor: colors.blueLineEdit,
        borderColor: {
            left: colors.blueGrey,
            top: colors.blueGrey,
            right: colors.blueGrey,
            bottom: colors.blueGrey,
        },
    },
    gridLayout: {
        item: {
            labelBorder: '1px solid',
            labelBorderColor: colors.blueGrey,
            width: '100%',
        },
    },
    hBoxLayout: {
        height: 'auto',
        width: '100%',
        item: {
            width: '100%',
        },
    },
    vBoxLayout: {
        justifyContent: 'flex-start',
    },
    button: {
        color: colors.yellow,
        border: '1px solid',
        borderRadius: '4px',
        width: 'auto',
        fontFamily: 'DejaVu Sans Mono',
        backgroundColor: colors.blueAlternate,
        borderColor: {
            left: colors.border,
            top: colors.border,
            right: colors.darkBorder,
            bottom: colors.darkBorder,
        },
        active: {
            backgroundColor: colors.blueLineEdit,
            borderColor: {
                left: colors.white,
                top: colors.white,
                right: colors.white,
                bottom: colors.white,
            },
        },
        disabled: {
            color: colors.grey,
        },
        focus: {
            outline: 'none',
        },
        hover: {
            backgroundColor: colors.blueBackground,
        },
        toggle: {
            onBackgroundColor: colors.blueHeader,
            offBackgroundColor: colors.blueAlternate,
        },
        bgToggle: {
            onBackgroundColor: '#5DB6FF',
            offBackgroundColor: colors.blueAlternate,
        },
    },
    checkbox: {
        display: 'flex',
        input: {
            margin: '2px',
            height: '12px',
            width: '12px',
            appearance: 'unset',
            background: colors.white,
            checked: {
                appearance: 'unset',
                background: '#37a068',
            },
        },
        label: {
            color: 'white',
        },
    },
};
export default catizTheme;
//# sourceMappingURL=catiz-theme.js.map